export default {
  title: 'Aggiungi carta di credito',
  buttons: {
    save: 'Salva',
  },
  feedback: {
    success: 'Carta aggiunta con successo',
  },
};
